import React from "react";
import DocumentTitle from "react-document-title";
import "./orgSelect.less";
import AXIOS from "../../api/axios";
import { parseQuery } from "../../utils/tools";
import Toast from "../../utils/toast";

// 第二教室APP - 机构介绍
export default class OrgSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lists: [],
        };
        const queryObj = parseQuery(window.location.search.slice(1));
        this.channelId = queryObj.channelid;
    }
    componentDidMount() {
        this.getOrgList();
    }
    getOrgList() {
        AXIOS.getOrgList({}, (res, err) => {
            if (err) {
                Toast.info({ text: err.errorMessage });
            } else {
                this.setState({
                    lists: res,
                });
            }
        });
    }
    handleSelect = (item) => {
        AXIOS.changeOrg({ data: { channelId: item.channelId } }, (res, err) => {
            if (err) {
                Toast.info({ text: err.errorMessage });
            } else {
                sessionStorage.setItem("selectChannelId", item.channelId);
                this.handleBack();
            }
        });
    };
    handleBack = () => {
        this.props.history.goBack();
    };
    render() {
        const { lists } = this.state;
        return (
            <DocumentTitle title="机构中心">
                <div className="org-select-wrap">
                    {lists.map((item) => (
                        <div
                            className="org-list"
                            onClick={() => this.handleSelect(item)}
                            key={item.channelId}
                        >
                            {item.logoUrl ? (
                                <img
                                    src={item.logoUrl}
                                    alt=""
                                    className="org-logo"
                                />
                            ) : null}
                            <div className="org-name">{item.name}</div>
                            {item.isSelect === 1 ? (
                                <div className="org-current">当前</div>
                            ) : null}
                        </div>
                    ))}
                    <div className="back-btn" onClick={this.handleBack}>
                        返回
                    </div>
                </div>
            </DocumentTitle>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/lesson2/orgSelect.jsx